const initialeState = {
    geoserverApiUrl : null,
    ignApiKey       : null,
    ui_theme        : "light",
    windowsSize     :null,
    init            :false,

}

const AppReducer = (state=initialeState, action) => {
    switch (action.type) {
        case "SET_APP_INIT":
            return {
                ...state,
                init: action.data
            }
        case "SET_GEOSERVER_API_URL":
            return {
                ...state,
                geoserverApiUrl:  action.data
            }
        case "SET_IGN_API_KEY":
            return{
                ...state,
                ignApiKey: action.data
            }
        case "SET_UI_THEME":
            return{
                ...state,
                ui_theme: action.data
            }
        case "UPDATE_WINDOWS_SIZE":
            return{
                ...state,
                windowsSize: action.data
            }
        default:
            return state
    }
}

export default AppReducer
